export const buildNumber = '20260622.1';
export const version = 'main';
export const latestCommit = '66d01cec44f5a2372f50700debfa752f71b66384';
